import React, { useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import NewHero from "./components/NewHero";
import TrustBadges from "./components/TrustBadges";
import ServicesSection from "./components/ServicesSection";
import TestimonialsSection from "./components/TestimonialsSection";
import WhoWeAre from "./components/WhoWeAre";
import CTASection from "./components/CTASection";
import QuoteWizard from "./components/QuoteWizard";
import Admin from "./components/Admin";
import Leads from "./components/Leads";
import ThankYou from "./components/ThankYou";
import { Toaster } from "./components/ui/sonner";

const Home = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <NewHero />
      <TrustBadges />
      <ServicesSection />
      <TestimonialsSection />
      <WhoWeAre />
      <CTASection />
      <Footer />
    </div>
  );
};

const QuoteCalculatorPage = () => {
  const [showWizard, setShowWizard] = useState(true);

  const handleCloseWizard = () => {
    setShowWizard(false);
  };

  return (
    <div className="min-h-screen bg-slate-50 py-20">
      <div className="container mx-auto px-4">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-slate-900 mb-4">Instant Quote Calculator</h1>
          <p className="text-slate-600">Internal tool - Get instant pricing for customers</p>
        </div>
        {showWizard && <QuoteWizard onClose={handleCloseWizard} />}
        {!showWizard && (
          <div className="text-center">
            <button 
              onClick={() => setShowWizard(true)}
              className="bg-emerald-600 text-white px-6 py-3 rounded-lg hover:bg-emerald-700"
            >
              Start New Quote
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/thank-you" element={<ThankYou />} />
          <Route path="/quote-calculator" element={<QuoteCalculatorPage />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/leads" element={<Leads />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
